<template>
  <div class="backTop">
    <div
      class="backtop-mask"
      v-if="isShowEdit"
      @click="isShowEdit = false"
    ></div>
    <div
      v-show="$store.state.myRender.common.fixed_back_top.pcShowBtn || $store.state.myRender.common.fixed_back_top.mbShowBtn"
      class="back_top_wrapper"
      @mousemove="hasdashed=true"
      @mouseleave="hasdashed=false"
      :style="{border: hasdashed && $store.state.app.view_pattern === 'pc' ? '1px dashed #333' : ''}"
    >
      <div
        class="edit_cont"
        v-if="$store.state.app.view_pattern === 'pc'"
      >
        <span
          class="sys_icon el-icon-edit"
          :title="$t('view_back_top_index_104')"
          @click="showEditModule"
        ></span>
        <span
          class="sys_icon el-icon-view"
          :title="$t('view_back_top_index_105')"
          @click="hiddeBackTop"
        ></span>
      </div>
      <a
        class="back_top_content"
        @click="back_to_top"
      >
        <div
          v-if="back_top_style.button_style == 'default'"
          class="back_top_fill"
          :style="{
              borderRadius:iconStyle.borderRadius,
              background: iconStyle.id !== 'default-0' && iconStyle.id !== 'default-1' ? '' : iconStyle.backgroundColor,
              color:iconStyle.color
              }"
        >
          <span
            class="iconClass"
            :class="iconStyle.iconName"
          ></span>
        </div>
        <div
          v-else
          class="back_top_fill"
          style="box-shadow:none"
        >
          <img
            :src="back_top_style.button_color.custom.url || defaultUrl"
            width="100%"
            alt=""
          >
        </div>
      </a>
    </div>
    <backToTopEdit
      v-if="isShowEdit"
      :iconList="iconList"
      @changeIcon="iconStyleChange"
      @changeShow="isShowEdit = false"
    ></backToTopEdit>
  </div>
</template>



<script>
import i18n from '../../language/index'

import backToTopEdit from "./edit"
export default {
  components: { backToTopEdit },
  data () {
    return {
      hasdashed: false,
      iconStyle: {
        id: '',
        borderRadius: '',
        canChangeColor: true,
        backgroundColor: '',
        iconName: '',
        color: ''
      },
      defaultUrl: require('@/assets/image/imgnot.jpg'),
      iconList: [
        {
          id: 'default-0',
          borderRadius: '50%',
          canChangeColor: true,
          backgroundColor: 'rgba(0, 0, 0, 1)',
          iconName: 'el-icon-arrow-up',
          color: '#fff'
        },
        {
          id: 'default-1',
          borderRadius: '4px',
          canChangeColor: true,
          backgroundColor: 'rgba(0, 0, 0, 1)',
          iconName: 'el-icon-arrow-up',
          color: '#fff'
        },
        {
          id: 'default-2',
          borderRadius: '50%',
          canChangeColor: false,
          backgroundColor: '',
          iconName: 'zd_back_top_icon1',
          color: 'rgba(0, 0, 0, 0.5)'
        },
        {
          id: 'default-3',
          borderRadius: '4px',
          canChangeColor: false,
          backgroundColor: '',
          iconName: 'el-icon-arrow-up',
          color: 'rgba(0, 0, 0, 1)'
        },
        {
          id: 'default-4',
          borderRadius: '50%',
          canChangeColor: false,
          backgroundColor: '',
          iconName: 'zd_back_top_icon2',
          color: 'rgba(0, 0, 0, 0.5)'
        },
        {
          id: 'default-5',
          borderRadius: '50%',
          canChangeColor: false,
          backgroundColor: '',
          iconName: 'zd_back_top_icon3',
          color: 'rgba(0, 0, 0, 0.5)'
        }
      ],
      isShowEdit: false
    }
  },
  computed: {
    back_top_style () {
      return this.$store.state.myRender.common.fixed_back_top
    }
  },
  mounted () {
    if (this.back_top_style.button_color.radio_val === "default") {
      this.back_top_style.button_color.default.backgroundColor = this.$store.state.myRender.common.theme_color
    }
    this.iconStyle = Object.assign(this.iconStyle, this.back_top_style.button_color.default)
    if (this.iconStyle.id !== 'default-0' && this.iconStyle.id !== 'default-1') {
      this.iconStyle = Object.assign(this.iconStyle, {
        backgroundColor: ''
      })
    }
  },
  methods: {
    showEditModule () {
      this.isShowEdit = true
      this.hasdashed = false
    },
    back_to_top () {
      this.$emit("bindClickBackTop")
    },
    hiddeBackTop () {
      this.$store.state.myRender.common.fixed_back_top.mbShowBtn = false
      this.$store.commit("myRender/SET_show_back_top", false)
      this.hasdashed = false
    },
    iconStyleChange (val) {
      if (val.id !== 'default-0' && val.id !== 'default-1') {
        val.backgroundColor = ''
      }
      this.iconStyle = Object.assign(this.iconStyle, val)
      this.back_top_style.button_color.default = val
    }
  },
  watch: {
    '$store.state.myRender.common.theme_color' (v) {
      if (this.back_top_style.button_color.radio_val === "default") {
        this.back_top_style.button_color.default.backgroundColor = this.$store.state.myRender.common.theme_color
      }
      this.iconStyle = Object.assign(this.iconStyle, this.back_top_style.button_color.default)
      if (this.iconStyle.id !== 'default-0' && this.iconStyle.id !== 'default-1') {
        this.iconStyle = Object.assign(this.iconStyle, {
          backgroundColor: ''
        })
      }
    }
  }
}
</script>

<style>
.zd_back_top_icon3 {
  box-shadow: none;
  background: url(~@/assets/image/mbg01.png) no-repeat;
  background-position: -326px -708px;
}
.zd_back_top_icon2 {
  background: url(~@/assets/image/mbg01.png) no-repeat;
  background-position: -388px -700px;
}
.zd_back_top_icon1 {
  background: url(~@/assets/image/mbg01.png) no-repeat;
  background-position: -458px -700px;
}
</style>

<style lang="scss" scoped>
.backtop-mask {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
.back_top_wrapper {
  position: fixed;
  width: 66px;
  height: 70px;
  right: 21px;
  bottom: 47px;
  z-index: 999;
  box-sizing: border-box;
  &:hover {
    .back_top_content {
      bottom: 50%;
      cursor: pointer;
    }
    .edit_cont {
      display: block;
    }
  }
  .edit_cont {
    position: absolute;
    display: none;
    right: 0;
    top: -25px;
    font-size: 0;
    .sys_icon {
      display: inline-block;
      vertical-align: top;
      width: 24px;
      height: 24px;
      color: #fff;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      background-color: #444;
      cursor: pointer;
      &:hover {
        background-color: #222;
      }
    }
  }
  .back_top_content {
    position: absolute;
    left: 50%;
    margin-left: -24px;
    bottom: calc(50% - 7px);
    margin-bottom: -24px;
    transition: bottom 0.3s ease;
    .back_top_fill {
      width: 48px;
      height: 48px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
      color: #fff;
      background-color:#fff;
      .iconClass {
        display: inline-block;
        vertical-align: top;
        width: 100%;
        height: 100%;
        line-height: 48px;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/back_top/index.vue